import React from "react"
import { clx } from "../utils/clx"

interface DividerProps extends React.ComponentPropsWithoutRef<"div"> {}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ className, children, ...props }, forwardedRef) => (
    <div
      ref={forwardedRef}
      className={clx(
        "mx-auto my-6 flex w-full items-center justify-between gap-3 text-sm",
        "text-ui-fg-subtle",
        className,
      )}
      {...props}
    >
      {children ? (
        <>
          <div
            className={clx(
              "h-[1px] w-full",
              "bg-ui-border-strong",
            )}
          />
          <div className="whitespace-nowrap text-inherit">{children}</div>
          <div
            className={clx(
              "h-[1px] w-full",
              "bg-ui-border-strong",
            )}
          />
        </>
      ) : (
        <div
          className={clx(
            "h-[1px] w-full",
            "bg-ui-border-strong",
          )}
        />
      )}
    </div>
  ),
)

Divider.displayName = "Divider"

export { Divider }
